import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import type {GridStorageTypes} from '@Components/base-grid';
import type {GridEmailSignupFormItemStorage} from '@Components/email-signup-form-grid/components/email-signup-form-grid';
import type {AjaxResponse} from '@Utils/ajax.util';
import {MODAL_IDS, openModal} from '@Components/modal-container-deprecated';

export const SIGNUP_GRID_ID = 'signupGrid';
export const deleteEmailSignupFormLoading = 'deleteEmailSignupForm';
export const duplicateEmailSignupFormLoading = 'duplicateEmailSignupForm';
export const updateEmailSignupFormLoadingNotifications = 'updateEmailSignupFormLoadingNotifications';

export const findGridItem = (grid: GridStorageTypes, gridItemId: string) => {
  return grid.items.find((item: GridItemStorage) => {
    return item.id === gridItemId;
  }) as GridEmailSignupFormItemStorage;
};

export const isSignupFormDeleteForbidden = (response: AjaxResponse): boolean => {
  return response.code === 'signup-form-in-event';
};

export const showSignupFormDeletionForbiddenDialog = (): void => {
  openModal(MODAL_IDS.ERROR_MODAL_ID, {
    message: window.i18next.t('pmwjs_signup_form_deletion_forbidden'),
    log: false,
  });
};